import {FormikMessages} from 'constants/Validation';

import * as Yup from 'yup';

const resetSchema = Yup.object().shape({
  password: Yup.string().required(FormikMessages.PASSWORD_REQUIRED),
  password_confirmation: Yup.string()
    .required(FormikMessages.CONFIRM_PASSWORD_REQUIRED)
    .oneOf([Yup.ref('password'), null], FormikMessages.PASSWORD_MATCH),
});

export default resetSchema;
